export const AUTHENTICATION_HEADER = "Authorization";
export const GIGPRO_LOCATION_HEADER = "X-Gigpro-Location-Id";
export const GA4_CLIENT_ID_HEADER = "X-Gigpro-GA-Client-Id";
